var frontLoggerModule = angular.module('frontLoggerModule', []);
